import { defineCopy } from "@tami/core/intl";

import { WHATSAPP_SCRIPT_COPY_EN_US } from "./en-us/whatsapp-script.copy";
import { WHATSAPP_SCRIPT_COPY_ES_ES } from "./es-es/whatsapp-script.copy";

export const WHATSAPP_SCRIPT_COPY_PT_BR = {
  whatsappIntro: {
    narrative:
      "A Tãmi mora no seu WhatsApp: ela organiza o dia, agenda conteúdo e acompanha seus números — tudo na conversa.",
  },
  whatsappAgenda: {
    narrative:
      "Todo dia, de manhã, a Tãmi te manda a agenda pronta: postagens, eventos e vencimentos do dia num só lugar.",
    callout:
      "Bom dia com a agenda na mão — disparada automaticamente, sem você pedir.",
  },
  whatsappContent: {
    narrative:
      "Teve uma ideia? Manda no WhatsApp. A Tãmi cria o planejamento na Central de Conteúdo na hora.",
    callout:
      "Você descreve, a Tãmi planeja: rede, formato e data já registrados.",
  },
  whatsappEvent: {
    narrative:
      "Precisa marcar uma gravação ou reunião? Ela adiciona direto na sua agenda e ainda te lembra no dia.",
    callout:
      "Eventos do calendário criados pela conversa, com lembrete garantido.",
  },
  whatsappPerformance: {
    narrative:
      "E no fim da semana chega o resumo de performance: engajamento, posts e seguidores, comparados com a semana anterior.",
    callout:
      "Resumo semanal automático — seus números chegam mastigados no WhatsApp.",
  },
  whatsappOutro: {
    narrative:
      "Da agenda da manhã ao resumo da semana: a Tãmi cuida da rotina enquanto você foca em criar.",
  },
} as const;

export const WHATSAPP_SCRIPT_COPY = defineCopy(WHATSAPP_SCRIPT_COPY_PT_BR, {
  "en-US": WHATSAPP_SCRIPT_COPY_EN_US,
  "es-ES": WHATSAPP_SCRIPT_COPY_ES_ES,
});
